"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NluApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(NluApi, _BasicApi);

  /**
   * @constructor
   */
  function NluApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        fingerPrintTokenFactory = _ref.fingerPrintTokenFactory,
        nluApiUrl = _ref.nluApiUrl;
    (0, _classCallCheck2.default)(this, NluApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NluApi).call(this, {
      userTokenFactory: userTokenFactory,
      fingerPrintTokenFactory: fingerPrintTokenFactory
    }));
    _this.nluApiUrl = nluApiUrl;
    return _this;
  }

  (0, _createClass2.default)(NluApi, [{
    key: "_paginateOverList",
    value: function () {
      var _paginateOverList2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(callList, params) {
        var queryParams, last, totalItems, result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryParams = _lodash.default.clone(params);
                last = null;
                totalItems = [];

              case 3:
                if (last) {
                  queryParams.last = last;
                }

                _context.next = 6;
                return callList.call(this, queryParams);

              case 6:
                result = _context.sent;
                last = result.last;
                totalItems = _lodash.default.chain(totalItems).concat(result.items).value();

              case 9:
                if (last && !_lodash.default.isEmpty(result.items)) {
                  _context.next = 3;
                  break;
                }

              case 10:
                return _context.abrupt("return", totalItems);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _paginateOverList(_x, _x2) {
        return _paginateOverList2.apply(this, arguments);
      }

      return _paginateOverList;
    }()
  }, {
    key: "indexLimits",
    value: function () {
      var _indexLimits = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        var headers;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context2.sent;
                return _context2.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/administration/limits/index"), headers).then(function (response) {
                  return response.data;
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function indexLimits() {
        return _indexLimits.apply(this, arguments);
      }

      return indexLimits;
    }()
  }, {
    key: "getLimits",
    value: function () {
      var _getLimits = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(path) {
        var headers;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context3.sent;
                return _context3.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/administration/limits"), _objectSpread({}, headers, {
                  params: {
                    path: path
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getLimits(_x3) {
        return _getLimits.apply(this, arguments);
      }

      return getLimits;
    }()
  }, {
    key: "postLimits",
    value: function () {
      var _postLimits = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref2) {
        var accountId, limits, headers;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                accountId = _ref2.accountId, limits = _ref2.limits;
                _context4.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context4.sent;
                return _context4.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/administration/limits"), {
                  accountId: accountId,
                  limits: limits
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function postLimits(_x4) {
        return _postLimits.apply(this, arguments);
      }

      return postLimits;
    }()
  }, {
    key: "listAllPrebuiltEntities",
    value: function () {
      var _listAllPrebuiltEntities = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5() {
        var _ref3,
            language,
            headers,
            _args5 = arguments;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref3 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, language = _ref3.language;
                _context5.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context5.sent;
                return _context5.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/kb/entities/prebuilt/all"), _objectSpread({}, headers, {
                  params: {
                    language: language
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function listAllPrebuiltEntities() {
        return _listAllPrebuiltEntities.apply(this, arguments);
      }

      return listAllPrebuiltEntities;
    }()
  }, {
    key: "listEntities",
    value: function () {
      var _listEntities = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6() {
        var _ref4,
            type,
            kbId,
            versionId,
            last,
            limit,
            headers,
            _args6 = arguments;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref4 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, type = _ref4.type, kbId = _ref4.kbId, versionId = _ref4.versionId, last = _ref4.last, limit = _ref4.limit;
                _context6.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context6.sent;
                return _context6.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/kb/entities/").concat(type), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    versionId: versionId,
                    last: last,
                    limit: limit
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function listEntities() {
        return _listEntities.apply(this, arguments);
      }

      return listEntities;
    }()
  }, {
    key: "listFeatures",
    value: function () {
      var _listFeatures = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7() {
        var _ref5,
            kbId,
            versionId,
            last,
            limit,
            headers,
            _args7 = arguments;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _ref5 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, kbId = _ref5.kbId, versionId = _ref5.versionId, last = _ref5.last, limit = _ref5.limit;
                _context7.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context7.sent;
                return _context7.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/phraselists"), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    versionId: versionId,
                    last: last,
                    limit: limit
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function listFeatures() {
        return _listFeatures.apply(this, arguments);
      }

      return listFeatures;
    }()
  }, {
    key: "listAllEntities",
    value: function () {
      var _listAllEntities = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8() {
        var _ref6,
            type,
            versionId,
            kbId,
            limit,
            _args8 = arguments;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _ref6 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, type = _ref6.type, versionId = _ref6.versionId, kbId = _ref6.kbId, limit = _ref6.limit;
                return _context8.abrupt("return", this._paginateOverList(this.listEntities, {
                  type: type,
                  kbId: kbId,
                  versionId: versionId,
                  limit: limit
                }));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function listAllEntities() {
        return _listAllEntities.apply(this, arguments);
      }

      return listAllEntities;
    }()
  }, {
    key: "listAllFeatures",
    value: function () {
      var _listAllFeatures = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9() {
        var _ref7,
            kbId,
            versionId,
            limit,
            _args9 = arguments;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _ref7 = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {}, kbId = _ref7.kbId, versionId = _ref7.versionId, limit = _ref7.limit;
                return _context9.abrupt("return", this._paginateOverList(this.listFeatures, {
                  kbId: kbId,
                  versionId: versionId,
                  limit: limit
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function listAllFeatures() {
        return _listAllFeatures.apply(this, arguments);
      }

      return listAllFeatures;
    }()
  }, {
    key: "listKnowledgeBases",
    value: function () {
      var _listKnowledgeBases = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10() {
        var _ref8,
            last,
            limit,
            headers,
            _args10 = arguments;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _ref8 = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {}, last = _ref8.last, limit = _ref8.limit;
                _context10.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context10.sent;
                return _context10.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/knowledge-base"), _objectSpread({}, headers, {
                  params: {
                    last: last,
                    limit: limit
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function listKnowledgeBases() {
        return _listKnowledgeBases.apply(this, arguments);
      }

      return listKnowledgeBases;
    }()
  }, {
    key: "listAllKnowledgeBases",
    value: function () {
      var _listAllKnowledgeBases = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11() {
        var _ref9,
            limit,
            _args11 = arguments;

        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _ref9 = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {}, limit = _ref9.limit;
                return _context11.abrupt("return", this._paginateOverList(this.listKnowledgeBases, {
                  limit: limit
                }));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function listAllKnowledgeBases() {
        return _listAllKnowledgeBases.apply(this, arguments);
      }

      return listAllKnowledgeBases;
    }()
  }, {
    key: "listApplications",
    value: function () {
      var _listApplications = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12() {
        var _ref10,
            kbId,
            text,
            pattern,
            versionId,
            last,
            limit,
            projection,
            headers,
            _args12 = arguments;

        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _ref10 = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {}, kbId = _ref10.kbId, text = _ref10.text, pattern = _ref10.pattern, versionId = _ref10.versionId, last = _ref10.last, limit = _ref10.limit, projection = _ref10.projection;
                _context12.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context12.sent;
                return _context12.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/applications"), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    last: last,
                    limit: limit,
                    text: text,
                    pattern: pattern,
                    versionId: versionId,
                    projection: projection
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function listApplications() {
        return _listApplications.apply(this, arguments);
      }

      return listApplications;
    }()
  }, {
    key: "listAllApplications",
    value: function () {
      var _listAllApplications = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13() {
        var _ref11,
            kbId,
            text,
            pattern,
            versionId,
            limit,
            projection,
            _args13 = arguments;

        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _ref11 = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {}, kbId = _ref11.kbId, text = _ref11.text, pattern = _ref11.pattern, versionId = _ref11.versionId, limit = _ref11.limit, projection = _ref11.projection;
                return _context13.abrupt("return", this._paginateOverList(this.listApplications, {
                  kbId: kbId,
                  text: text,
                  pattern: pattern,
                  versionId: versionId,
                  limit: limit,
                  projection: projection
                }));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function listAllApplications() {
        return _listAllApplications.apply(this, arguments);
      }

      return listAllApplications;
    }()
  }, {
    key: "listIntentsLabels",
    value: function () {
      var _listIntentsLabels = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref12) {
        var appId, headers;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                appId = _ref12.appId;
                _context14.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context14.sent;
                return _context14.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/intents/labels"), _objectSpread({}, headers, {
                  params: {
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function listIntentsLabels(_x5) {
        return _listIntentsLabels.apply(this, arguments);
      }

      return listIntentsLabels;
    }()
  }, {
    key: "listUtterances",
    value: function () {
      var _listUtterances = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref13) {
        var kbId, last, limit, query, headers;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                kbId = _ref13.kbId, last = _ref13.last, limit = _ref13.limit, query = (0, _objectWithoutProperties2.default)(_ref13, ["kbId", "last", "limit"]);
                _context15.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context15.sent;
                return _context15.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/utterances"), _objectSpread({}, headers, {
                  params: _objectSpread({
                    kbId: kbId,
                    last: last,
                    limit: limit
                  }, query)
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function listUtterances(_x6) {
        return _listUtterances.apply(this, arguments);
      }

      return listUtterances;
    }()
  }, {
    key: "listPatterns",
    value: function () {
      var _listPatterns = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(_ref14) {
        var kbId, last, limit, query, headers;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                kbId = _ref14.kbId, last = _ref14.last, limit = _ref14.limit, query = (0, _objectWithoutProperties2.default)(_ref14, ["kbId", "last", "limit"]);
                _context16.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context16.sent;
                return _context16.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/patterns"), _objectSpread({}, headers, {
                  params: _objectSpread({
                    kbId: kbId,
                    last: last,
                    limit: limit
                  }, query)
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function listPatterns(_x7) {
        return _listPatterns.apply(this, arguments);
      }

      return listPatterns;
    }()
  }, {
    key: "listAllUtterances",
    value: function () {
      var _listAllUtterances = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(_ref15) {
        var kbId, limit, query;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                kbId = _ref15.kbId, limit = _ref15.limit, query = (0, _objectWithoutProperties2.default)(_ref15, ["kbId", "limit"]);
                return _context17.abrupt("return", this._paginateOverList(this.listUtterances, _objectSpread({
                  kbId: kbId,
                  limit: limit
                }, query)));

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function listAllUtterances(_x8) {
        return _listAllUtterances.apply(this, arguments);
      }

      return listAllUtterances;
    }()
  }, {
    key: "listAllPatterns",
    value: function () {
      var _listAllPatterns = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(_ref16) {
        var kbId, limit, query;
        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                kbId = _ref16.kbId, limit = _ref16.limit, query = (0, _objectWithoutProperties2.default)(_ref16, ["kbId", "limit"]);
                return _context18.abrupt("return", this._paginateOverList(this.listPatterns, _objectSpread({
                  kbId: kbId,
                  limit: limit
                }, query)));

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function listAllPatterns(_x9) {
        return _listAllPatterns.apply(this, arguments);
      }

      return listAllPatterns;
    }()
  }, {
    key: "listPrebuiltModels",
    value: function () {
      var _listPrebuiltModels = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(_ref17) {
        var limit, last, query, headers;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                limit = _ref17.limit, last = _ref17.last, query = (0, _objectWithoutProperties2.default)(_ref17, ["limit", "last"]);
                _context19.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context19.sent;
                return _context19.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/prebuilt-models"), _objectSpread({}, headers, {
                  params: _objectSpread({
                    limit: limit,
                    last: last
                  }, query)
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function listPrebuiltModels(_x10) {
        return _listPrebuiltModels.apply(this, arguments);
      }

      return listPrebuiltModels;
    }()
  }, {
    key: "listAllPrebuiltModels",
    value: function () {
      var _listAllPrebuiltModels = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20(params) {
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this._paginateOverList(this.listPrebuiltModels, params));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function listAllPrebuiltModels(_x11) {
        return _listAllPrebuiltModels.apply(this, arguments);
      }

      return listAllPrebuiltModels;
    }() // TODO: delete it(for internal use)

  }, {
    key: "createPrebuiltModel",
    value: function () {
      var _createPrebuiltModel = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee21(body) {
        var headers;
        return _regenerator.default.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context21.sent;
                return _context21.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/prebuilt-models"), body, headers).then(function (response) {
                  return response.data;
                }));

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function createPrebuiltModel(_x12) {
        return _createPrebuiltModel.apply(this, arguments);
      }

      return createPrebuiltModel;
    }()
  }, {
    key: "removePrebuiltModelFromKM",
    value: function () {
      var _removePrebuiltModelFromKM = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee22(_ref18) {
        var prebuiltModelId, kbId, headers;
        return _regenerator.default.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                prebuiltModelId = _ref18.prebuiltModelId, kbId = _ref18.kbId;
                _context22.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context22.sent;
                return _context22.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/knowledge-base/prebuilt-model"), _objectSpread({}, headers, {
                  params: {
                    prebuiltModelId: prebuiltModelId,
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function removePrebuiltModelFromKM(_x13) {
        return _removePrebuiltModelFromKM.apply(this, arguments);
      }

      return removePrebuiltModelFromKM;
    }()
  }, {
    key: "addPrebuiltModelToKM",
    value: function () {
      var _addPrebuiltModelToKM = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee23(_ref19) {
        var kbId, prebuiltModelId, appId, appName, shouldCreateNewApplication, responses, entities, headers;
        return _regenerator.default.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                kbId = _ref19.kbId, prebuiltModelId = _ref19.prebuiltModelId, appId = _ref19.appId, appName = _ref19.appName, shouldCreateNewApplication = _ref19.shouldCreateNewApplication, responses = _ref19.responses, entities = _ref19.entities;
                _context23.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context23.sent;
                return _context23.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/prebuilt-model"), {
                  kbId: kbId,
                  appId: appId,
                  prebuiltModelId: prebuiltModelId,
                  appName: appName,
                  shouldCreateNewApplication: shouldCreateNewApplication,
                  responses: responses,
                  entities: entities
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function addPrebuiltModelToKM(_x14) {
        return _addPrebuiltModelToKM.apply(this, arguments);
      }

      return addPrebuiltModelToKM;
    }()
  }, {
    key: "getPrebuiltModelDetails",
    value: function () {
      var _getPrebuiltModelDetails = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee24(_ref20) {
        var kbId, prebuiltModelId, headers;
        return _regenerator.default.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                kbId = _ref20.kbId, prebuiltModelId = _ref20.prebuiltModelId;
                _context24.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context24.sent;
                return _context24.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/knowledge-base/prebuilt-model"), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    prebuiltModelId: prebuiltModelId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function getPrebuiltModelDetails(_x15) {
        return _getPrebuiltModelDetails.apply(this, arguments);
      }

      return getPrebuiltModelDetails;
    }()
  }, {
    key: "createKnowledgeBase",
    value: function () {
      var _createKnowledgeBase = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee25(_ref21) {
        var name, desc, imageSrc, config, culture, extensions, headers;
        return _regenerator.default.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                name = _ref21.name, desc = _ref21.desc, imageSrc = _ref21.imageSrc, config = _ref21.config, culture = _ref21.culture, extensions = _ref21.extensions;
                _context25.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context25.sent;
                return _context25.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base"), {
                  name: name,
                  desc: desc,
                  imageSrc: imageSrc,
                  config: config,
                  culture: culture,
                  extensions: extensions
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function createKnowledgeBase(_x16) {
        return _createKnowledgeBase.apply(this, arguments);
      }

      return createKnowledgeBase;
    }()
  }, {
    key: "createApplication",
    value: function () {
      var _createApplication = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee26(_ref22) {
        var kbId, name, desc, culture, model_features, headers;
        return _regenerator.default.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                kbId = _ref22.kbId, name = _ref22.name, desc = _ref22.desc, culture = _ref22.culture, model_features = _ref22.model_features;
                _context26.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context26.sent;
                return _context26.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/applications"), {
                  kbId: kbId,
                  name: name,
                  desc: desc,
                  culture: culture,
                  model_features: model_features
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function createApplication(_x17) {
        return _createApplication.apply(this, arguments);
      }

      return createApplication;
    }()
  }, {
    key: "createIntent",
    value: function () {
      var _createIntent = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee27(_ref23) {
        var name, type, kbId, appId, postprocessFlows, customData, features, headers;
        return _regenerator.default.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                name = _ref23.name, type = _ref23.type, kbId = _ref23.kbId, appId = _ref23.appId, postprocessFlows = _ref23.postprocessFlows, customData = _ref23.customData, features = _ref23.features;
                _context27.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context27.sent;
                return _context27.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/intents"), {
                  name: name,
                  type: type,
                  postprocessFlows: postprocessFlows,
                  customData: customData,
                  features: features
                }, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function createIntent(_x18) {
        return _createIntent.apply(this, arguments);
      }

      return createIntent;
    }()
  }, {
    key: "createUtterance",
    value: function () {
      var _createUtterance = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee28(_ref24) {
        var appId, kbId, autoGenerated, updatedCache, text, intent, entities, headers;
        return _regenerator.default.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                appId = _ref24.appId, kbId = _ref24.kbId, autoGenerated = _ref24.autoGenerated, updatedCache = _ref24.updatedCache, text = _ref24.text, intent = _ref24.intent, entities = _ref24.entities;
                _context28.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context28.sent;
                return _context28.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/utterances"), {
                  autoGenerated: autoGenerated,
                  updatedCache: updatedCache,
                  text: text,
                  intent: intent,
                  entities: entities
                }, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function createUtterance(_x19) {
        return _createUtterance.apply(this, arguments);
      }

      return createUtterance;
    }()
  }, {
    key: "createPattern",
    value: function () {
      var _createPattern = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee29(_ref25) {
        var appId, kbId, pattern, intent, entities, headers;
        return _regenerator.default.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                appId = _ref25.appId, kbId = _ref25.kbId, pattern = _ref25.pattern, intent = _ref25.intent, entities = _ref25.entities;
                _context29.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context29.sent;
                return _context29.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/patterns"), {
                  pattern: pattern,
                  intent: intent,
                  entities: entities
                }, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function createPattern(_x20) {
        return _createPattern.apply(this, arguments);
      }

      return createPattern;
    }()
  }, {
    key: "createPair",
    value: function () {
      var _createPair = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee30(_ref26) {
        var kbId, applicationName, intentName, intentType, utteranceText, headers;
        return _regenerator.default.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                kbId = _ref26.kbId, applicationName = _ref26.applicationName, intentName = _ref26.intentName, intentType = _ref26.intentType, utteranceText = _ref26.utteranceText;
                _context30.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context30.sent;
                return _context30.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/pair"), {
                  kbId: kbId,
                  applicationName: applicationName,
                  intentName: intentName,
                  intentType: intentType,
                  utteranceText: utteranceText
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function createPair(_x21) {
        return _createPair.apply(this, arguments);
      }

      return createPair;
    }()
  }, {
    key: "batchCreatePairs",
    value: function () {
      var _batchCreatePairs = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee31(_ref27) {
        var kbId, utterances, headers;
        return _regenerator.default.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                kbId = _ref27.kbId, utterances = _ref27.utterances;
                _context31.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context31.sent;
                return _context31.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/pairs"), {
                  kbId: kbId,
                  utterances: utterances
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function batchCreatePairs(_x22) {
        return _batchCreatePairs.apply(this, arguments);
      }

      return batchCreatePairs;
    }()
  }, {
    key: "batchCreatePairsFile",
    value: function () {
      var _batchCreatePairsFile = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee32(_ref28) {
        var kbId, fileUrl, headers;
        return _regenerator.default.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                kbId = _ref28.kbId, fileUrl = _ref28.fileUrl;
                _context32.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context32.sent;
                return _context32.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/pairs/file"), {
                  kbId: kbId,
                  fileUrl: fileUrl
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function batchCreatePairsFile(_x23) {
        return _batchCreatePairsFile.apply(this, arguments);
      }

      return batchCreatePairsFile;
    }()
  }, {
    key: "createPatternPair",
    value: function () {
      var _createPatternPair = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee33(_ref29) {
        var kbId, applicationName, intentName, intentType, patternText, patternEntities, headers;
        return _regenerator.default.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                kbId = _ref29.kbId, applicationName = _ref29.applicationName, intentName = _ref29.intentName, intentType = _ref29.intentType, patternText = _ref29.patternText, patternEntities = _ref29.patternEntities;
                _context33.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context33.sent;
                return _context33.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/patterns/pair"), {
                  kbId: kbId,
                  applicationName: applicationName,
                  intentName: intentName,
                  intentType: intentType,
                  patternText: patternText,
                  patternEntities: patternEntities
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function createPatternPair(_x24) {
        return _createPatternPair.apply(this, arguments);
      }

      return createPatternPair;
    }()
  }, {
    key: "createPairsCsv",
    value: function () {
      var _createPairsCsv = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee34(_ref30) {
        var kbId, fileUrl, applicationName, delimiter, headers;
        return _regenerator.default.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                kbId = _ref30.kbId, fileUrl = _ref30.fileUrl, applicationName = _ref30.applicationName, delimiter = _ref30.delimiter;
                _context34.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context34.sent;
                return _context34.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/pair/csv"), {
                  kbId: kbId,
                  applicationName: applicationName,
                  fileUrl: fileUrl,
                  delimiter: delimiter
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function createPairsCsv(_x25) {
        return _createPairsCsv.apply(this, arguments);
      }

      return createPairsCsv;
    }()
  }, {
    key: "createEntity",
    value: function () {
      var _createEntity = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee35(_ref31) {
        var type, kbId, name, roles, rest, headers;
        return _regenerator.default.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                type = _ref31.type, kbId = _ref31.kbId, name = _ref31.name, roles = _ref31.roles, rest = (0, _objectWithoutProperties2.default)(_ref31, ["type", "kbId", "name", "roles"]);
                _context35.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context35.sent;
                return _context35.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/kb/entities/").concat(type), NluApi._getEntityBody(type, _objectSpread({
                  name: name,
                  roles: roles
                }, rest)), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function createEntity(_x26) {
        return _createEntity.apply(this, arguments);
      }

      return createEntity;
    }()
  }, {
    key: "createFeature",
    value: function () {
      var _createFeature = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee36(_ref32) {
        var kbId, name, mode, words, enabledForAllModels, headers;
        return _regenerator.default.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                kbId = _ref32.kbId, name = _ref32.name, mode = _ref32.mode, words = _ref32.words, enabledForAllModels = _ref32.enabledForAllModels;
                _context36.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context36.sent;
                return _context36.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/phraselists"), {
                  name: name,
                  mode: mode,
                  words: words,
                  enabledForAllModels: enabledForAllModels
                }, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function createFeature(_x27) {
        return _createFeature.apply(this, arguments);
      }

      return createFeature;
    }()
  }, {
    key: "updateKnowledgeBase",
    value: function () {
      var _updateKnowledgeBase = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee37(knowledgeBase) {
        var headers;
        return _regenerator.default.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context37.sent;
                return _context37.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/knowledge-base"), knowledgeBase, headers).then(function (response) {
                  return response.data;
                }));

              case 4:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function updateKnowledgeBase(_x28) {
        return _updateKnowledgeBase.apply(this, arguments);
      }

      return updateKnowledgeBase;
    }()
  }, {
    key: "updateApplication",
    value: function () {
      var _updateApplication = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee38(_ref33) {
        var kbId, id, name, desc, model_features, headers;
        return _regenerator.default.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                kbId = _ref33.kbId, id = _ref33.id, name = _ref33.name, desc = _ref33.desc, model_features = _ref33.model_features;
                _context38.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context38.sent;
                return _context38.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/applications"), {
                  kbId: kbId,
                  id: id,
                  name: name,
                  desc: desc,
                  model_features: model_features
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function updateApplication(_x29) {
        return _updateApplication.apply(this, arguments);
      }

      return updateApplication;
    }()
  }, {
    key: "updateIntent",
    value: function () {
      var _updateIntent = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee39(_ref34) {
        var name, type, id, appId, kbId, postprocessFlows, customData, features, headers;
        return _regenerator.default.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                name = _ref34.name, type = _ref34.type, id = _ref34.id, appId = _ref34.appId, kbId = _ref34.kbId, postprocessFlows = _ref34.postprocessFlows, customData = _ref34.customData, features = _ref34.features;
                _context39.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context39.sent;
                return _context39.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/intents"), {
                  name: name,
                  type: type,
                  postprocessFlows: postprocessFlows,
                  customData: customData,
                  features: features
                }, _objectSpread({}, headers, {
                  params: {
                    id: id,
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function updateIntent(_x30) {
        return _updateIntent.apply(this, arguments);
      }

      return updateIntent;
    }()
  }, {
    key: "updateUtterance",
    value: function () {
      var _updateUtterance = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee40(_ref35) {
        var appId, kbId, utterance, headers;
        return _regenerator.default.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                appId = _ref35.appId, kbId = _ref35.kbId, utterance = _ref35.utterance;
                _context40.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context40.sent;
                return _context40.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/utterances"), utterance, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function updateUtterance(_x31) {
        return _updateUtterance.apply(this, arguments);
      }

      return updateUtterance;
    }()
  }, {
    key: "updatePattern",
    value: function () {
      var _updatePattern = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee41(_ref36) {
        var appId, kbId, pattern, headers;
        return _regenerator.default.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                appId = _ref36.appId, kbId = _ref36.kbId, pattern = _ref36.pattern;
                _context41.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context41.sent;
                return _context41.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/patterns"), pattern, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function updatePattern(_x32) {
        return _updatePattern.apply(this, arguments);
      }

      return updatePattern;
    }()
  }, {
    key: "updatePair",
    value: function () {
      var _updatePair = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee42(_ref37) {
        var kbId, applicationName, intentName, intentType, utterance, headers;
        return _regenerator.default.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                kbId = _ref37.kbId, applicationName = _ref37.applicationName, intentName = _ref37.intentName, intentType = _ref37.intentType, utterance = _ref37.utterance;
                _context42.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context42.sent;
                return _context42.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/knowledge-base/pair"), {
                  kbId: kbId,
                  applicationName: applicationName,
                  intentName: intentName,
                  intentType: intentType,
                  utterance: utterance
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function updatePair(_x33) {
        return _updatePair.apply(this, arguments);
      }

      return updatePair;
    }()
  }, {
    key: "batchUpdatePairs",
    value: function () {
      var _batchUpdatePairs = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee43(_ref38) {
        var kbId, utterances, headers;
        return _regenerator.default.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                kbId = _ref38.kbId, utterances = _ref38.utterances;
                _context43.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context43.sent;
                return _context43.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/knowledge-base/pairs"), utterances, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function batchUpdatePairs(_x34) {
        return _batchUpdatePairs.apply(this, arguments);
      }

      return batchUpdatePairs;
    }()
  }, {
    key: "updateEntity",
    value: function () {
      var _updateEntity = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee44(_ref39) {
        var type, id, kbId, name, roles, rest, headers;
        return _regenerator.default.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                type = _ref39.type, id = _ref39.id, kbId = _ref39.kbId, name = _ref39.name, roles = _ref39.roles, rest = (0, _objectWithoutProperties2.default)(_ref39, ["type", "id", "kbId", "name", "roles"]);
                _context44.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context44.sent;
                return _context44.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/kb/entities/").concat(type), NluApi._getEntityBody(type, _objectSpread({
                  name: name,
                  roles: roles
                }, rest)), _objectSpread({}, headers, {
                  params: {
                    id: id,
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function updateEntity(_x35) {
        return _updateEntity.apply(this, arguments);
      }

      return updateEntity;
    }()
  }, {
    key: "updateFeature",
    value: function () {
      var _updateFeature = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee45(_ref40) {
        var kbId, id, name, mode, words, enabledForAllModels, _ref40$activated, activated, headers;

        return _regenerator.default.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                kbId = _ref40.kbId, id = _ref40.id, name = _ref40.name, mode = _ref40.mode, words = _ref40.words, enabledForAllModels = _ref40.enabledForAllModels, _ref40$activated = _ref40.activated, activated = _ref40$activated === void 0 ? true : _ref40$activated;
                _context45.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context45.sent;
                return _context45.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/phraselists"), {
                  name: name,
                  mode: mode,
                  words: words,
                  enabledForAllModels: enabledForAllModels,
                  activated: activated
                }, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    id: id
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function updateFeature(_x36) {
        return _updateFeature.apply(this, arguments);
      }

      return updateFeature;
    }()
  }, {
    key: "updatePrebuiltEntities",
    value: function () {
      var _updatePrebuiltEntities = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee46(_ref41) {
        var kbId, list, headers;
        return _regenerator.default.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                kbId = _ref41.kbId, list = _ref41.list;
                _context46.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context46.sent;
                return _context46.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/kb/entities/prebuilt"), list, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function updatePrebuiltEntities(_x37) {
        return _updatePrebuiltEntities.apply(this, arguments);
      }

      return updatePrebuiltEntities;
    }()
  }, {
    key: "deleteKnowledgeBase",
    value: function () {
      var _deleteKnowledgeBase = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee47(_ref42) {
        var id, headers;
        return _regenerator.default.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                id = _ref42.id;
                _context47.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context47.sent;
                return _context47.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/knowledge-base"), _objectSpread({}, headers, {
                  params: {
                    id: id
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function deleteKnowledgeBase(_x38) {
        return _deleteKnowledgeBase.apply(this, arguments);
      }

      return deleteKnowledgeBase;
    }()
  }, {
    key: "deleteApplication",
    value: function () {
      var _deleteApplication = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee48(_ref43) {
        var kbId, appId, headers;
        return _regenerator.default.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                kbId = _ref43.kbId, appId = _ref43.appId;
                _context48.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context48.sent;
                return _context48.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/applications"), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function deleteApplication(_x39) {
        return _deleteApplication.apply(this, arguments);
      }

      return deleteApplication;
    }()
  }, {
    key: "deleteIntent",
    value: function () {
      var _deleteIntent = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee49(_ref44) {
        var id, appId, kbId, headers;
        return _regenerator.default.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                id = _ref44.id, appId = _ref44.appId, kbId = _ref44.kbId;
                _context49.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context49.sent;
                return _context49.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/intents"), _objectSpread({}, headers, {
                  params: {
                    id: id,
                    kbId: kbId,
                    appId: appId,
                    deleteUtterances: true
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function deleteIntent(_x40) {
        return _deleteIntent.apply(this, arguments);
      }

      return deleteIntent;
    }()
  }, {
    key: "deleteUtterance",
    value: function () {
      var _deleteUtterance = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee50(_ref45) {
        var id, kbId, headers;
        return _regenerator.default.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                id = _ref45.id, kbId = _ref45.kbId;
                _context50.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context50.sent;
                return _context50.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/utterances"), _objectSpread({}, headers, {
                  params: {
                    id: id,
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function deleteUtterance(_x41) {
        return _deleteUtterance.apply(this, arguments);
      }

      return deleteUtterance;
    }()
  }, {
    key: "batchDeleteUtterances",
    value: function () {
      var _batchDeleteUtterances = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee51(_ref46) {
        var ids, kbId, headers;
        return _regenerator.default.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                ids = _ref46.ids, kbId = _ref46.kbId;
                _context51.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context51.sent;
                return _context51.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/utterances/bulk/delete"), ids, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));

      function batchDeleteUtterances(_x42) {
        return _batchDeleteUtterances.apply(this, arguments);
      }

      return batchDeleteUtterances;
    }()
  }, {
    key: "deletePattern",
    value: function () {
      var _deletePattern = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee52(_ref47) {
        var id, kbId, headers;
        return _regenerator.default.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                id = _ref47.id, kbId = _ref47.kbId;
                _context52.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context52.sent;
                return _context52.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/patterns"), _objectSpread({}, headers, {
                  params: {
                    id: id,
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function deletePattern(_x43) {
        return _deletePattern.apply(this, arguments);
      }

      return deletePattern;
    }()
  }, {
    key: "deleteEntity",
    value: function () {
      var _deleteEntity = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee53(_ref48) {
        var type, id, kbId, headers;
        return _regenerator.default.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                type = _ref48.type, id = _ref48.id, kbId = _ref48.kbId;
                _context53.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context53.sent;
                return _context53.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/kb/entities/").concat(type), _objectSpread({}, headers, {
                  params: {
                    id: id,
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function deleteEntity(_x44) {
        return _deleteEntity.apply(this, arguments);
      }

      return deleteEntity;
    }()
  }, {
    key: "deleteFeature",
    value: function () {
      var _deleteFeature = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee54(_ref49) {
        var id, kbId, headers;
        return _regenerator.default.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                id = _ref49.id, kbId = _ref49.kbId;
                _context54.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context54.sent;
                return _context54.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/phraselists"), _objectSpread({}, headers, {
                  params: {
                    id: id,
                    kbId: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));

      function deleteFeature(_x45) {
        return _deleteFeature.apply(this, arguments);
      }

      return deleteFeature;
    }()
  }, {
    key: "getTrainStatus",
    value: function () {
      var _getTrainStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee55(_ref50) {
        var kbId, _ref50$versionId, versionId, headers;

        return _regenerator.default.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                kbId = _ref50.kbId, _ref50$versionId = _ref50.versionId, versionId = _ref50$versionId === void 0 ? null : _ref50$versionId;
                _context55.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context55.sent;
                return _context55.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/train/status"), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    versionId: versionId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function getTrainStatus(_x46) {
        return _getTrainStatus.apply(this, arguments);
      }

      return getTrainStatus;
    }()
  }, {
    key: "train",
    value: function () {
      var _train = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee56(_ref51) {
        var kbId, flowId, phraseId, sessionId, autoPublish, headers;
        return _regenerator.default.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                kbId = _ref51.kbId, flowId = _ref51.flowId, phraseId = _ref51.phraseId, sessionId = _ref51.sessionId, autoPublish = _ref51.autoPublish;
                _context56.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context56.sent;
                return _context56.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/kb/train"), null, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    flowId: flowId,
                    phraseId: phraseId,
                    sessionId: sessionId,
                    autoPublish: autoPublish
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function train(_x47) {
        return _train.apply(this, arguments);
      }

      return train;
    }()
  }, {
    key: "trainForTest",
    value: function () {
      var _trainForTest = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee57(_ref52) {
        var kbId, flowId, phraseId, sessionId, headers;
        return _regenerator.default.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                kbId = _ref52.kbId, flowId = _ref52.flowId, phraseId = _ref52.phraseId, sessionId = _ref52.sessionId;
                _context57.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context57.sent;
                return _context57.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/kb/train/test"), null, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    flowId: flowId,
                    phraseId: phraseId,
                    sessionId: sessionId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function trainForTest(_x48) {
        return _trainForTest.apply(this, arguments);
      }

      return trainForTest;
    }()
  }, {
    key: "publish",
    value: function () {
      var _publish = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee58(_ref53) {
        var kbId, _ref53$versionId, versionId, headers;

        return _regenerator.default.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                kbId = _ref53.kbId, _ref53$versionId = _ref53.versionId, versionId = _ref53$versionId === void 0 ? null : _ref53$versionId;
                _context58.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context58.sent;
                return _context58.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/kb/publish"), null, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    versionId: versionId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));

      function publish(_x49) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "recover",
    value: function () {
      var _recover = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee59(_ref54) {
        var kbId, versionId, headers;
        return _regenerator.default.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                kbId = _ref54.kbId, versionId = _ref54.versionId;
                _context59.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context59.sent;
                return _context59.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/kb/recover"), null, _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    versionId: versionId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));

      function recover(_x50) {
        return _recover.apply(this, arguments);
      }

      return recover;
    }()
  }, {
    key: "deleteVersion",
    value: function () {
      var _deleteVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee60(_ref55) {
        var kbId, versionId, headers;
        return _regenerator.default.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                kbId = _ref55.kbId, versionId = _ref55.versionId;
                _context60.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context60.sent;
                return _context60.abrupt("return", _axios.default.delete("".concat(this.nluApiUrl, "/kb/versions"), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    versionId: versionId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function deleteVersion(_x51) {
        return _deleteVersion.apply(this, arguments);
      }

      return deleteVersion;
    }()
  }, {
    key: "clone",
    value: function () {
      var _clone = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee61(_ref56) {
        var kbId, newName, headers;
        return _regenerator.default.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                kbId = _ref56.kbId, newName = _ref56.newName;
                _context61.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context61.sent;
                return _context61.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/clone"), {
                  newName: newName
                }, _objectSpread({}, headers, {
                  params: {
                    id: kbId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));

      function clone(_x52) {
        return _clone.apply(this, arguments);
      }

      return clone;
    }()
  }, {
    key: "export",
    value: function () {
      var _export2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee62(_ref57) {
        var kbId, isPublic, headers;
        return _regenerator.default.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                kbId = _ref57.kbId, isPublic = _ref57.isPublic;
                _context62.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context62.sent;
                return _context62.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/knowledge-base/export"), _objectSpread({}, headers, {
                  params: {
                    id: kbId,
                    isPublic: isPublic
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function _export(_x53) {
        return _export2.apply(this, arguments);
      }

      return _export;
    }()
  }, {
    key: "import",
    value: function () {
      var _import2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee63(_ref58) {
        var fileUrl, knowledgeBase, headers;
        return _regenerator.default.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                fileUrl = _ref58.fileUrl, knowledgeBase = _ref58.knowledgeBase;
                _context63.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context63.sent;
                return _context63.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/import"), {
                  fileUrl: fileUrl,
                  knowledgeBase: knowledgeBase
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function _import(_x54) {
        return _import2.apply(this, arguments);
      }

      return _import;
    }()
  }, {
    key: "importJson",
    value: function () {
      var _importJson = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee64(data) {
        var headers;
        return _regenerator.default.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context64.sent;
                return _context64.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/import/json"), data, headers).then(function (response) {
                  return response.data;
                }));

              case 4:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function importJson(_x55) {
        return _importJson.apply(this, arguments);
      }

      return importJson;
    }()
  }, {
    key: "importCsv",
    value: function () {
      var _importCsv = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee65(_ref59) {
        var fileUrl, knowledgeBase, applicationName, delimiter, headers;
        return _regenerator.default.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                fileUrl = _ref59.fileUrl, knowledgeBase = _ref59.knowledgeBase, applicationName = _ref59.applicationName, delimiter = _ref59.delimiter;
                _context65.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context65.sent;
                return _context65.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/knowledge-base/import/csv"), {
                  fileUrl: fileUrl,
                  knowledgeBase: knowledgeBase,
                  applicationName: applicationName,
                  delimiter: delimiter
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function importCsv(_x56) {
        return _importCsv.apply(this, arguments);
      }

      return importCsv;
    }()
  }, {
    key: "getProvisioningStatus",
    value: function () {
      var _getProvisioningStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee66(_ref60) {
        var appId, kbId, headers;
        return _regenerator.default.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                appId = _ref60.appId, kbId = _ref60.kbId;
                _context66.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context66.sent;
                return _context66.abrupt("return", _axios.default.get("".concat(this.nluApiUrl, "/provisioning/status"), _objectSpread({}, headers, {
                  params: {
                    kbId: kbId,
                    appId: appId
                  }
                })).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function getProvisioningStatus(_x57) {
        return _getProvisioningStatus.apply(this, arguments);
      }

      return getProvisioningStatus;
    }()
  }, {
    key: "updateProvisioningStatus",
    value: function () {
      var _updateProvisioningStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee67(_ref61) {
        var accountId, applicationId, status, kbId, isKb, headers;
        return _regenerator.default.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                accountId = _ref61.accountId, applicationId = _ref61.applicationId, status = _ref61.status, kbId = _ref61.kbId, isKb = _ref61.isKb;
                _context67.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context67.sent;
                return _context67.abrupt("return", _axios.default.put("".concat(this.nluApiUrl, "/provisioning/status"), {
                  accountId: accountId,
                  applicationId: applicationId,
                  status: status,
                  kbId: kbId,
                  isKb: isKb
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function updateProvisioningStatus(_x58) {
        return _updateProvisioningStatus.apply(this, arguments);
      }

      return updateProvisioningStatus;
    }()
  }, {
    key: "meaning",
    value: function () {
      var _meaning = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee68(data) {
        var headers;
        return _regenerator.default.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context68.sent;
                return _context68.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/meaning"), data, headers).then(function (response) {
                  return response.data;
                }));

              case 4:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, this);
      }));

      function meaning(_x59) {
        return _meaning.apply(this, arguments);
      }

      return meaning;
    }()
  }, {
    key: "testMeaning",
    value: function () {
      var _testMeaning = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee69(_ref62) {
        var q, appId, kbId, headers;
        return _regenerator.default.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                q = _ref62.q, appId = _ref62.appId, kbId = _ref62.kbId;
                _context69.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context69.sent;
                return _context69.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/meaning/test"), {
                  q: q,
                  appId: appId,
                  kbId: kbId
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function testMeaning(_x60) {
        return _testMeaning.apply(this, arguments);
      }

      return testMeaning;
    }()
  }, {
    key: "qnaMeaning",
    value: function () {
      var _qnaMeaning = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee70(_ref63) {
        var q, appId, kbId, isKb, headers;
        return _regenerator.default.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                q = _ref63.q, appId = _ref63.appId, kbId = _ref63.kbId, isKb = _ref63.isKb;
                _context70.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context70.sent;
                return _context70.abrupt("return", _axios.default.post("".concat(this.nluApiUrl, "/qna/meaning"), {
                  q: q,
                  appId: appId,
                  kbId: kbId,
                  isKb: isKb
                }, headers).then(function (response) {
                  return response.data;
                }));

              case 5:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, this);
      }));

      function qnaMeaning(_x61) {
        return _qnaMeaning.apply(this, arguments);
      }

      return qnaMeaning;
    }()
  }], [{
    key: "_getEntityBody",
    value: function _getEntityBody(type, data) {
      var base = {
        name: data.name,
        roles: data.roles
      };

      switch (type) {
        case 'simple':
          return _objectSpread({}, base, {
            features: data.features,
            children: data.children
          });

        case 'regex':
          return _objectSpread({}, base, {
            regexPattern: data.regexPattern
          });

        case 'prebuilt':
          return base;

        case 'postprocess':
          return {
            name: data.name,
            processFlow: data.processFlow
          };

        case 'list':
          return _objectSpread({}, base, {
            subLists: data.subLists
          });

        case 'patternany':
          return base;

        default:
          throw new Error("Unknown entity type ".concat(type));
      }
    }
  }]);
  return NluApi;
}(_basic.default);

var _default = NluApi;
exports.default = _default;